import React, { useState } from 'react';
import { PixelInput } from './pixel-input';
import { useUpdateAnswerMutation } from '../../redux/survey/survey.endpoints';

interface AnswerPixelProps {
  answerId: string;
  extSurveyId: string;
  questionId: string;
  initialPixel?: string;
  answerTitle: string;
  onClose?: () => void;
}

export const AnswerPixel: React.FC<AnswerPixelProps> = ({ answerId, extSurveyId, questionId, initialPixel, answerTitle, onClose }) => {
  const [updateAnswer] = useUpdateAnswerMutation();
  const [isVisible, setIsVisible] = useState(true);

  const handleSave = async(value: string | null) => {
    try {
      setIsVisible(false);
      onClose?.();
      await updateAnswer({
        id: answerId,
        survey: extSurveyId,
        survey_question: questionId,
        ext_survey_id: extSurveyId,
        answer_pixel: value,
        title: answerTitle,
      }).unwrap();
    } catch (error) {
      console.error('Error updating answer pixel:', error);
    }
  };

  if (!isVisible) return null;

  return (
    <PixelInput
      initialPixel={initialPixel}
      onSave={handleSave}
      showToggle={false}
    />
  );
};